import wheel from './images/wheel.png';
import React from "react";
import './styles/wheel.css';

/*
	This Wheel class will return a visual wheel element.
	It can be clicked, locked, return the value it lands on, etc.
*/
class Wheel extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			rotationPercent: 7.5, // start at a rotation of 7.5 deg to make the wheel start between two wedges
			isLocked: false
		}
		this.rotate = this.rotate.bind(this);


	}

	handleChangeValue = event => this.setState({rotationPercent: event.target.rotationPercent});

	onChange(f){
		this.props.spinValue(f);
	}
	getRotation() {
		// get the remainder of a wheel spin (we don't care how many times it span around) and multiple by -1 since it rotates other direction
		let rotationRemainder = (this.state.rotationPercent % 360) * -1;

		// angle of one wedge of the wheel (24 wedges)
		let piecewidth = 360/24;

		// store data of what each wedge is
		let pieces = [
			{ "id": 1, "value": -1 }, // bankrupt
			{ "id": 2, "value": 600 },
			{ "id": 3, "value": 250 },
			{ "id": 4, "value": 300 },
			{ "id": 5, "value": 700 },
			{ "id": 6, "value": 100 },
			{ "id": 7, "value": 450 },
			{ "id": 8, "value": 5000 },
			{ "id": 9, "value": 800 },
			{ "id": 10, "value": 250 },
			{ "id": 11, "value": 600 },
			{ "id": 12, "value": 350 },
			{ "id": 13, "value": 750 },
			{ "id": 14, "value": 0 }, // lose a turn
			{ "id": 15, "value": 400 },
			{ "id": 16, "value": 300 },
			{ "id": 17, "value": 900 },
			{ "id": 18, "value": -1 },
			{ "id": 19, "value": 550 },
			{ "id": 20, "value": 200 },
			{ "id": 21, "value": 350 },
			{ "id": 22, "value": 900 },
			{ "id": 23, "value": 150 },
			{ "id": 24, "value": 550 },
			{ "id": 25, "value": -1 },
		]

		// determine what wedge the rotation remainder means we are at
		let index = 0;
		index = Math.round(rotationRemainder / piecewidth);

		// return the data for the wedge we are at

		console.log(pieces[index].value);
		// return 0;

		// console.log
		return pieces[index].value;
	}

	// lock/unlock wheel spinning
	lock() {
		// this.setState({
		// 	isLocked: true
		// })
		localStorage.setItem('isWheelLocked', "1");
	}
	unlock () {
		// this.setState({
		// 	isLocked: false
		// })
		localStorage.setItem('isWheelLocked', "0");
	}


	isLocked(){
		var temp = localStorage.getItem('isWheelLocked');
		return temp

	}

	// rotate the wheel
	rotate() {

		// console.log(this.isLocked)
		// if we are locked, do nothing!
		if(this.isLocked() === "1") {
			// console.log("we are ia isLocked: " + this.isLocked)
			return;
		}

		// if we are not locked, lock!
		else {
			this.lock();
		}

		// strength of spin, somewhere between 1000 and 2000 degrees
		var rand = Math.floor(Math.random() * 1000) + 1000;
		var rot = -rand + this.state.rotationPercent;
		this.setState({
			rotationPercent: rot // apply new rotation
		})
		function delay(milliseconds){
			return new Promise(resolve => {
				setTimeout(resolve, milliseconds);
			});
		}
		async function change(Wheel) {
			await delay(2000);
			Wheel.onChange(Wheel.getRotation());
		}
		change(this);
	}

	render() {
		return (
			<Child
				rotationPercent = {this.state.rotationPercent}
				onChangeValue = {this.handleChangeValue}
				rotate = {this.rotate}
			/>
		);
	}
}

/*
	This Child class is used to help allow for handling the changing of values.
*/
class Child extends React.Component {

	render() {
	  	return (
			<div>
				<img className="wheelimg" style={{transform: `rotate(${this.props.rotationPercent}deg)`}} src={wheel} onClick={this.props.rotate} onChange={

				this.props.onChangeValue

			} alt="Wheel"/>
			<div className='pointer' ></div>
			</div>

	  	)
	}
}

export default Wheel
